import type { SizeScale, TypePresets } from './types';

export const BRAVEMOVE_TYPE: TypePresets = {
  display: { family: 'Inter', weight: 900, letterSpacing: -0.04 },
  h1: { family: 'Inter', weight: 800, letterSpacing: -0.03 },
  h2: { family: 'Inter', weight: 700, letterSpacing: -0.02 },
  h3: { family: 'Inter', weight: 700, letterSpacing: -0.015 },
  body: { family: 'Inter', weight: 500, letterSpacing: 0 },
  body2: { family: 'Inter', weight: 400, letterSpacing: 0 },
  caption: { family: 'Inter', weight: 600, letterSpacing: 0.04 },
  mono: { family: 'JetBrains Mono', weight: 600, letterSpacing: 0.01 },
  arabic: { family: 'Noto Sans Arabic', weight: 500, letterSpacing: 0 },
};

export const BRAVEMOVE_SIZE: SizeScale = {
  hero: 72,
  h1: 44,
  h2: 32,
  h3: 22,
  body: 15,
  small: 13,
  caption: 11,
  mono: 12,
};
